const MonitoringProgram = () => {
  class BasemapControl {
    onAdd(map) {
      this._map = map;
      this._container = document.createElement("div");
      this._container.className = "mapboxgl-ctrl mapboxgl-ctrl-group";
      this._container.style.padding = `3px`;
      const streetIconsWrapper = document.createElement("div");
      streetIconsWrapper.className = "icon-wrapper";
      streetIconsWrapper.style.borderBottom = "1px solid #dddddd";
      streetIconsWrapper.style.padding = "3px";
      const streetsIcon = document.createElement("i");
      streetsIcon.className = "material-icons";
      streetsIcon.style.verticalAlign = "middle";
      streetsIcon.style.cursor = "pointer";
      streetsIcon.textContent = "terrain";
      const satelliteIconsWrapper = document.createElement("div");
      satelliteIconsWrapper.className = "icon-wrapper";
      satelliteIconsWrapper.style.padding = "3px";
      const satelliteIcon = document.createElement("i");
      satelliteIcon.className = "material-icons";
      satelliteIcon.style.verticalAlign = "middle";
      satelliteIcon.style.cursor = "pointer";
      satelliteIcon.textContent = "satellite";
      streetIconsWrapper.appendChild(streetsIcon);
      satelliteIconsWrapper.appendChild(satelliteIcon);
      this._container.appendChild(streetIconsWrapper);
      this._container.appendChild(satelliteIconsWrapper);
      streetIconsWrapper.addEventListener("click", function (event) {
        map.setStyle("mapbox://styles/ccbwqportal/ckcm66s2h1bvn1ipgtmdl9341");
      });
      satelliteIconsWrapper.addEventListener("click", function (event) {
        map.setStyle("mapbox://styles/ccbwqportal/ckcm4r5ug164r1jsen6iiaa91");
      });
      return this._container;
    }

    onRemove() {
      this._container.parentNode.removeChild(this._container);
      this._map = undefined;
    }
  }

  mapboxgl.accessToken =
    "pk.eyJ1IjoiY2Nid3Fwb3J0YWwiLCJhIjoiY2plcmdqcnB2MDYzbTM0dW13aWp6cXhnbiJ9.wnHy3esIvSyv_MdNX_nwqw";
  const map = new mapboxgl.Map({
    container: "monitoring-program-map",
    style: "mapbox://styles/ccbwqportal/ckcm66s2h1bvn1ipgtmdl9341",
    zoom: 12,
    center: [-104.854032, 39.639983],
  });

  map.on("load", function (event) {
    const nav = new mapboxgl.NavigationControl();
    map.addControl(nav, "top-left");
    map.addControl(new BasemapControl(), "top-right");
  });
};
